import React from 'react';
import moment from 'moment';
import { Label, Popup } from 'semantic-ui-react';
import { isValidUUID } from '../../../libs/isValidUUIDUtility';

const Time = ({ value, facilitytimezone, entityid }) => {
  if (isValidUUID(entityid)) {
    return (
      <span>
        {facilitytimezone
          ? moment.utc(value).tz(facilitytimezone).format('MM/DD/YYYY h:mm a')
          : moment.utc(value).format('MM/DD/YYYY h:mm a')}
      </span>
    );
  } else {
    return <span>{moment.utc(value).format('MM/DD/YYYY h:mm a')}</span>;
  }
};

const FormatP2PDate = ({
  value,
  facilitytimezone,
  entityid,
  scheduleOption,
}) => {
  if (value) {
    return (
      <>
        <Time
          value={value}
          facilitytimezone={facilitytimezone}
          entityid={entityid}
        />
      </>
    );
  } else {
    return scheduleOption && 'Physician Advisor to Schedule Peer-To-Peer';
  }
};

const QueuePendingIndicator = ({ row }) => {
  return (
    <Popup
      trigger={
        <Label
          data-entity-id={row.entityid}
          data-admission-id={row.admissionid}
          data-is-pending={true}
          color='orange'
          style={{ fontSize: '10pt', width: '100%', textAlign: 'Center' }}
        >
          P
        </Label>
      }
      content={
        <FormatP2PDate
          value={row.scheduled_date_time}
          scheduleOption={row.schedule_option_selected}
          entityid={row.entityid}
          facilitytimezone={row.facilitytimezone}
        />
      }
      disabled={!row.schedule_option_selected}
      flowing
      inverted
      position='right center'
      size='small'
    />
  );
};

export default QueuePendingIndicator;
